
import { computed, defineComponent, reactive, ref, toRefs, watch, nextTick } from "vue";
import House from "./House.vue";
import Customer from "./Customer.vue";
import Other from "./Other.vue";
import { Toast } from "vant";

export type UserInfo = {
  id: string;
  head_pic: string;
  name: string;
  department_name: string;
  duty_name: string;
  place: string;
};
export default defineComponent({
  name: "ChooseVisitorTarget",
  components: { House, Customer, Other },
  props: {
    show: { type: Boolean, required: true }
  },
  emits: ["confirm", "update:show"],
  setup(props, { emit }) {
    const { show } = toRefs(props);
    const popupShow = computed({
      get() {
        return show.value;
      },
      set(value) {
        emit("update:show", value);
      }
    });
    const state = reactive({
      other: {},
      customer: {},
      house: {}
    });
    const updateState = (data: any, type: string) => {
      if (type === "customer") {
        [state.house, state.other] = [{}, {}];
        state.customer = data;
      } else if (type === "house") {
        [state.customer, state.other] = [{}, {}];
        state.house = data;
      } else if (type === "other") {
        [state.customer, state.house] = [{}, {}];
        state.other = data;
      }
    };

    const value = ref("");
    const active = ref("");
    const confirm = () => {
      const len1 = Object.keys(state.customer).length;
      const len2 = Object.keys(state.house).length;
      const len3 = Object.keys(state.other).length;
      if (!len1 && !len2 && !len3) return Toast.fail("请选择被访对象");

      popupShow.value = false;
      emit("confirm", {
        type: active.value,
        value: state[active.value]
      });
    };

    const customerRef = ref<any>(null);
    const houseRef = ref<any>(null);
    const otherRef = ref<any>(null);

    const customerList = ref([]);
    const houseList = ref([]);
    const otherList = ref([]);

    const showTab = computed(() => {
      const emptyArrays = [customerList.value, houseList.value, otherList.value].filter(list => list.length === 0);
      return emptyArrays.length >= 2;
    });

    const initPage = async () => {
      await nextTick();
      [customerList.value, houseList.value, otherList.value] = await Promise.all([
        customerRef.value?.onSearch("index"),
        houseRef.value?.onSearch("index"),
        otherRef.value?.onSearch("index")
      ]);

      if (!customerList.value.length && !houseList.value.length) active.value = "other";
      else if (!customerList.value.length) active.value = "house";
      else active.value = "customer";
    };

    watch(
      () => popupShow.value,
      val => {
        if (val) initPage();
      }
    );

    return {
      customerList,
      houseList,
      otherList,
      updateState,
      customerRef,
      houseRef,
      otherRef,
      value,
      popupShow,
      active,
      confirm,
      state,
      showTab
    };
  }
});
